module.exports = __webpack_public_path__ + "static/media/seed5.a698dc2f.svg";